import Messages from '@core/scripts/components/messages';
import MessageBroker from 'deprecated-shared-ui/components/message-broker';
import throttle from '@core/scripts/helper/throttle';
import JshModule from "@core/scripts/helper/jsh-module";

const {moduleScope, config} = JshModule('checkout/toggle-animation');
let wrapper = moduleScope.querySelector(config.wrapper);
wrapper.classList.add('toggle__red-bar-wrapper');
let redBar;

createRedBar();

let inputs = moduleScope.querySelectorAll('[jsh-toggle-input]');
for (let i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('change', changed);

    // Run initial positioning and sizing of the pre-selected red bar
    if (inputs[i].checked) {
        animate(inputs[i]);
    }
}

const throttledResized = throttle(resized.bind);
MessageBroker.subscribe(Messages.WINDOW.RESIZED, throttledResized);

function animate(input) {
    const boundary = input.closest('[jsh-toggle-boundary]');
    const target = boundary.querySelector('[jsh-toggle-target]');

    // move
    const wrapperX = wrapper.getBoundingClientRect().left;
    const targetX = target.getBoundingClientRect().left;
    const absoluteX = targetX - wrapperX;
    redBar.style.transform = `translateX(${absoluteX}px)`;

    // resize
    redBar.style.width = target.offsetWidth + 'px';
}

function createRedBar() {
    redBar = document.createElement('div');
    redBar.classList.add('toggle__red-bar');

    wrapper.insertAdjacentElement('beforeend', redBar);
}

function changed(e) {
    const input = e.currentTarget;

    if (!input.checked) {
        return;
    }

    animate(input);
}

function resized() {
    for (let i = 0; i < inputs.length; i++) {
        if (!inputs[i].checked) {
            continue;
        }

        animate(inputs[i]);
    }
}
